import QueryManager from "../../../utils/QueryManager";
import { getLocalStorageKey } from "../../../settings";
import dayjs from "dayjs";

const curLocalStorageKey = getLocalStorageKey("widgets_filters");

let widgetFiltersSerializableDates: string[] = [
  'DateFrom',
  'DateTo'
]

let widgetFiltersSerializableJoins: string[] = [

]

class WidgetsFiltersManagerClass extends QueryManager {
}

const WidgetFiltersManager = new WidgetsFiltersManagerClass({
  serializable: { dates: widgetFiltersSerializableDates, joins: widgetFiltersSerializableJoins },
  localStorageKey: curLocalStorageKey
});

export default WidgetFiltersManager;
